<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;width:200px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/server.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Ads</span>
            </div>
          </router-link>
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:26px;">
          </div>
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div style="width:100%;margin-top:40px;">
            <div style="width:100%;margin-bottom:24px;;display:flex;justify-content:space-between;align-items:center;">
              <div class="history-title-text">Ads Status</div>
              <div>
                <a-date-picker style="width:140px;" :default-value="AdsDate" @change="onDateChange" />
                <a-tree-select
                  v-model="treeValue"
                  style="width: 400px;margin-left:24px;"
                  :tree-data="treeData"
                  tree-checkable
                  allow-clear
                  :show-checked-strategy="SHOW_PARENT"
                  search-placeholder="Please select"
                  @change="onGroupChange"
                />
              </div>
            </div>
            <a-table
              style="margin-top:10px;"
              :loading="adsStatusLoading"
              :columns="adsStatusColumns" 
              :data-source="allAdsStatus"  
              :pagination="false"
              :rowKey="(record) => record.id"
            >
            </a-table>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'
import { TreeSelect } from 'ant-design-vue';
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

moment.suppressDeprecationWarnings = true

const adsStatusColumns = [
  {
    title: 'Site',
    dataIndex: 'site',
    onFilter: (value, record) => {
      return record.site.indexOf(value) === 0
    }
  },
  {
    title: 'landingpage',
    dataIndex: 'landingpage',
  },
  {
    title: 'Group',
    dataIndex: 'group_id',
    width:100,onFilter: (value, record) => {
      return record.group_id.indexOf(value) === 0
    }
  },
  {
    title: 'uptime',
    dataIndex: 'uptime',
    width:150,
  },
  {
    title: 'times',
    dataIndex: 'times',
    width:100,
  },
  {
    title: 'reslut',
    dataIndex: 'reslut',
  },
]
const treeData = [
  {
    title: 'Group 3',
    value: '3',
    key: '3',
  },
  {
    title: 'Group 4',
    value: '4',
    key: '4',
  },
  {
    title: 'Group 5',
    value: '5',
    key: '5',
  },
  {
    title: 'Group 7',
    value: '7',
    key: '7',
  },
];

export default {
  name: 'Information',
  components:{
    Bug
  },
  data() {
    return {
      SHOW_PARENT,
      adsStatusColumns,
      treeData,
      treeValue:[],
      avatar:'',
      moment,                             //  日期
      adsStatusLoading:false,
      allAdsStatus:[],
      AdsDate:moment()                             //  今天日期
      .format('YYYY-MM-DD')
      .slice(0, 10),
    }
  },
  methods: {
    getAdsStatus() {
      this.$post(api.tool.getAdsStatus, {
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        uptime:this.AdsDate,
        groups:this.treeValue,
        timestamp: Date.parse(new Date()),
      }).then((res) => {
        if (res.code === 200) {
          this.adsStatusLoading = false
          this.allAdsStatus = res.list.reverse()
          let list = res.list

          //  添加筛选内容
          // 站点
          let columns0Filter = []
          list.forEach(item => {
            let index = columns0Filter.findIndex(a => a.text == item.site)
            if (index === -1) {
              columns0Filter.push({
                text: item.site,
                value: item.site,
              })
            }
          })
          adsStatusColumns[0].filters = columns0Filter
          // 组
          let columns1Filter = []
          list.forEach(item => {
            let index = columns1Filter.findIndex(a => a.text == item.group_id)
            if (index === -1) {
              columns1Filter.push({
                text: item.group_id,
                value: item.group_id,
              })
            }
          })
          adsStatusColumns[2].filters = columns1Filter

          // 时间
          // let columns4Filter = []
          // list.forEach(item => {
          //   let index = columns4Filter.findIndex(a => a.text == item.ping_hour)
          //   if (index === -1) {
          //     columns4Filter.push({
          //       text: item.ping_hour,
          //       value: item.ping_hour,
          //     })
          //   }
          // })
          // adsStatusColumns[4].filters = columns4Filter
        }
      })
    },

    getUserInfo() {
      this.adsStatusLoading = true
      this.$post(api.tool.getUserInfo, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id: this.curUserId
      }).then((res) => {
        if (res.code === 200) {
          if(['3','4','5','7'].includes(res.list.group_id)) {
            this.treeValue.push(res.list.group_id)
          }else {
            this.treeValue.push('3')
          }
          console.log('getUserInfo接口正常');
          this.getAdsStatus()
        }
      })
    },

    onDateChange(date) {
      this.AdsDate = date.format('YYYY-MM-DD')
      this.getAdsStatus()
    },

    onGroupChange() {
      this.getAdsStatus()
    }
  },

  created() {
    console.log('localStorage');
    console.log(localStorage);
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
      this.getUserInfo()
    } else {
      this.$router.push({ path: '/' })
    }
  },

}
</script>

<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}
.container {
  /*width: 60%;*/
  width: 1198px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1659c4;
}

.history-title-text {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}


</style>
